import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { WArchivIcon } from '../elements/WArchivIcon';
import { WActionButton } from '../elements/WActionButton';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface WGalleryProps {
    title: string;
    entity: string;
    tid: number;
    key?: string;
    module?: string;
    view?: string;
    viewNotice?: JSX.Element;
    icon?: boolean;
    showMode?: boolean;
    onChange?: (action: string, row: any) => void;
}

export interface WGalleryState {
    data: any[]; // Wird NICHT für die Tabelle benötigt
    rowForForm: any;
    showGalleryInDialog?: boolean;
}

export class WGallery extends React.Component<WGalleryProps, WGalleryState> {

    public static VIEW_TABLE = 'table';
    public static VIEW_ICONS = 'icons';

    constructor(props: any) {
        super(props);
        this.state = {
            data: undefined,
            rowForForm: undefined
        };
        this.delItem = this.delItem.bind(this);
        this.load = this.load.bind(this);

    }

    @lazyInject(DataService) private dataService: DataService;

    private module: string = this.props.module || IDs.MOD_ETOOL;

    componentDidMount(): void {
        this.load();
    }

    delItem(tid: number): void {
        this.dataService.delData(IDs.ENT_GALLERY, this.module, { tid }, {}, () => {
            this.load();
        });
    }

    load(): void {
        const filter = {
            parent_entity: this.props.entity,
            parent_tid: this.props.tid,
            parent_key: this.props.key
        };
        this.dataService.loadData(IDs.ENT_GALLERY, filter, {}, (result: any, entityName: string, type: string) => {
            if (result[IDs.ENT_GALLERY]) {
                const data = result[IDs.ENT_GALLERY];
                this.setState({ data });
            }
        }, this.module);
    }

    render(): JSX.Element {
        if (this.props.showMode && !this.state.showGalleryInDialog) {
            return (this.state.data && this.state.data.length > 0) ? <div>{this.state.data.length + ' Datei(en)'}</div> : null;
        }

        if (!this.props.icon) {
            return this.renderContent(); // Wenn kein Icon, dann sofort den Content rendern
        } else {
            const style: React.CSSProperties = (this.state.data && this.state.data.length > 0) ? {} : { backgroundColor: 'lightgray' };
            return (
                <>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                        <WActionButton
                            label='Galerie'
                            tooltip='Galerie'
                            key='gallery'
                            style='medium'
                            action='gallery'
                            styleProps={{ marginRight: 5, ...style }}
                            onAction={() => this.setState({ showGalleryInDialog: true })}
                        />
                        {this.renderCount()}
                    </div>
                    {this.state.showGalleryInDialog &&
                        <div>
                            <DialogWrapper2
                                width={-1}
                                onAfterClose={() => this.setState({ showGalleryInDialog: false })}
                            >
                                {this.renderContent()}
                            </DialogWrapper2>
                        </div>
                    }
                </>
            );
        }
    }

    renderCount() {
        return <div style={{ paddingTop: 10, color: '#888' }}>
            {(this.state.data && this.state.data.length > 0) ? <span>{this.state.data.length} Datei(en)</span> :
                <span> Datei(en) hochladen</span>}
        </div>;
    }

    renderContent(): JSX.Element {
        const view = this.props.view;
        return (
            <div
                className={'Custom-ETA'}
                style={{ paddingBottom: 10 }}
            >
                <div>
                    {!this.state.rowForForm && view && view === WGallery.VIEW_ICONS && <>
                        {this.props.viewNotice}
                        <WActionButton
                            label='Hinzufügen'
                            insideText='Hinzufügen'
                            tooltip='Hinzufügen'
                            key='open'
                            action='add'
                            onAction={() => this.setState({ rowForForm: { tid: 0 } })}
                        />
                    </>}
                    {this.state.rowForForm &&
                        <WActionButton
                            label='Schließen'
                            insideText='Schließen'
                            tooltip='Schließen'
                            key='delete'
                            action='delete'
                            onAction={() => this.setState({ rowForForm: undefined })}
                        />
                    }
                </div>
                <div>
                    {(!view || view === WGallery.VIEW_TABLE) && this.renderTable()}
                    {(view && view === WGallery.VIEW_ICONS && !this.state.rowForForm) && this.renderIcons()}
                    {this.state.rowForForm && this.renderForm()}
                </div>
            </div>
        );
    }

    renderForm(): JSX.Element {
        const parent = {
            parent_entity: this.props.entity,
            parent_tid: this.props.tid,
            parent_key: this.props.key
        };
        return (
            <div style={{ maxWidth: 400, margin: 10 }}>
                <WFormsTableWrapper
                    entity={IDs.ENT_GALLERY}
                    module={this.module}
                    directEditFormularOf={{ tid: this.state.rowForForm.tid }}
                    inlineFormular
                    customClass={'Custom-ETA'}
                    customCssStyle={{ formcontainer: { minHeight: 350, height: 350 } }}
                    formLayout={'flowV2'}
                    formLayout2={'noneAutoSave'}
                    formPreset={parent}
                    preFilterServer={parent}
                    hideTitel
                    customFormConfig={{
                        parent_entity: { hidden: true },
                        parent_tid: { hidden: true },
                        parent_key: { hidden: true }
                    }}
                    onSaveDone={() => {
                        this.setState({ rowForForm: undefined });
                        this.load();
                    }}
                // onAfterAction={(action: string, row: any) => {
                //     if (action === 'saveDone' || action === 'delDone') {
                //         if (typeof this.props.onChange === 'function') {
                //             this.props.onChange(action, row);
                //         }
                //     }
                // }}
                />
            </div>
        );
    }

    renderIcons(): JSX.Element {
        if (!this.state.data) {
            return <div> Lade ...</div>;
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                {this.state.data.map((item: any, idx: number) => {
                    return (
                        <div
                            key={`legend-${idx}`}
                            style={{
                                border: '1px solid #aaa', boxSizing: 'border-box', margin: 5, maxWidth: 200, minWidth: 110,
                                borderTopLeftRadius: 10, borderTopRightRadius: 10
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#ddd', padding: 5, textAlign: 'center', fontSize: 12,
                                    borderTopLeftRadius: 10, borderTopRightRadius: 10
                                }}
                            >
                                {item.name}
                            </div>
                            <div
                                style={{
                                    backgroundColor: '#eee', padding: 5, textAlign: 'center', fontSize: 12,
                                    display: 'flex', flexDirection: 'row', justifyContent: 'center'
                                }}
                            >
                                <WActionButton
                                    label='Löschen'
                                    tooltip='Löschen'
                                    key='delete'
                                    action='delete'
                                    onAction={() => this.delItem(item.tid)}
                                />
                                <WActionButton
                                    label='Bearbeiten'
                                    tooltip='Bearbeiten'
                                    key='edit'
                                    action='edit'
                                    onAction={() => this.setState({ rowForForm: item })}
                                />
                            </div>
                            <div
                                style={{
                                    backgroundColor: '#fff', padding: 5, textAlign: 'center',
                                    display: 'flex', flexDirection: 'column'
                                }}
                            >
                                <WArchivIcon
                                    archivId={item.foto}
                                    module={this.props.module}
                                    previewSize={100}
                                    iconSize={100}
                                    fixedHight
                                    previewFontSize={11}
                                    hideFilename
                                />
                                <div style={{ fontSize: 11, color: '#444', marginTop: 5 }}>
                                    {item.beschreibung ? <span>{item.beschreibung}</span> : <span><i>Keine Beschreibung</i></span>}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    renderTable(): JSX.Element {
        const parent = {
            parent_entity: this.props.entity,
            parent_tid: this.props.tid,
            parent_key: this.props.key
        };
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_GALLERY}
                module={this.module}
                formPreset={parent}
                preFilterServer={parent}
                tablePageSize={10}
                customFormConfig={{
                    parent_entity: { hidden: true },
                    parent_tid: { hidden: true },
                    parent_key: { hidden: true }
                }}
                hiddenColumns={['parent_entity', 'parent_tid', 'parent_key']}
                actions={['edit', 'delete', 'add']}
                customClass={'Custom-ETA'}
                formLayout={'flowV2'}
                formLayout2={'noneAutoSave'}
                addLabel='Hinzufügen'
                hideFilterReset={true}
                hideExport={true}
                disableFilter={true}
                columnWidths={[295, 295, 100]}
                onAfterAction={(action: string, row: any) => {
                    if (action === 'saveDone' || action === 'delDone') {
                        this.load();
                        if (typeof this.props.onChange === 'function') {
                            this.props.onChange(action, row);
                        }
                    }
                }}
            />
        );
    }
}
